import { create } from 'zustand'

interface State {
    setSplashSecondary: (splashSecondary: string) => void
    splashSecondary: string
    clearSplashSecondary: () => void
}

export const useSecondarySplashStore = create<State>((set) => ({
    splashSecondary: '',
    setSplashSecondary: (splashSecondary) => set({ splashSecondary }),
    clearSplashSecondary: () => set({ splashSecondary: '' }),
}))
